import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default function postReducer(state = initialState.topUsers, action) {
    switch (action.type) {
        case (types.LOAD_TOPUSERS_SUCCESS):
            return action.users
        default:
            return state;
    }
}